import React from 'react';
import dateTimeFormat from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import T from "mrf/utils/T";

export default function LoginAttempts() {
    const formatColor = code =>
        code >= 200 && code < 300
            ? <span className='text-success'>{code}</span>
            : <span className='text-error'>{code}</span>

    const formatCode = code =>
        code === 200 ? <span className='text-success'><T>Successful</T></span>
        : code === 404 ? <span className='text-error'><T>Incorrect credentials</T></span>
        : code === 500 && <span className='text-error'><T>Internal server error</T></span>

    const fields = [
        { name: 'ID', key: 'id', },
        { name: 'Timestamp', key: 'recordTimestamp', map: dateTimeFormat },
        { name: 'Attempted Username', key: 'username', },
        { name: 'IP Address', key: 'remoteAddress', },
        { name: 'Status Code', key: 'statusCode', map: formatColor },
        { name: 'Status', key: 'statusCode', map: formatCode },
    ];

    return <ListCRUD
        singular='loginAttempt'
        fields={fields}
        disableNewButton
        disableViewButton
        disableEditButton
    />;
}
